var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getData, updateData, createData, } from "../../../utils/api/dataAccess";
// Get all Rainfall
export const getRainfall = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = `RainfallCategory/rainfall`;
    return getData(url);
});
// Create a new rainfall category
export const createRainfall = (item) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `RainfallCategory/rainfall-create`;
    return createData(url, item);
});
// Update an existing rainfall category
export const updateRainfall = (item) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `RainfallCategory/update`;
    return updateData(url, item);
});
// Delete a rainfall category
export const deleteRainfall = (item) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `RainfallCategory/rainfall-delete`;
    return updateData(url, item);
});
